import type { TipsContent } from "@/app/components/Tips";

const educationHistory: TipsContent = {
	summary:
		"List your degree, college/university, location, distinguishing academic honors, and other distinguishing information along with relevant training, certification and other professional credentials.",
	tips: [
		"Your education should only appear at the bottom of your resume (one page) because that's where recruiters will be looking for it.",
		"One exception is if you're applying for your first job out of college, then it's acceptable to include education information at the top of your resume.",
		{
			text: "Include every degree you've obtained in order of most advanced to least advanced.",
			items: [
				"School name",
				"Degree (B.A., B.S., etc)",
				"Major",
				"Minor",
				"Graduation year",
				"Honors or distinctions (Less than 5 years since graduation)",
				"GPA (Less than 5 years since graduation)",
				"Course taken (Applying for first job after graduation)",
				"Scholarships (less than 5 years since graduation)",
			],
		},
	],
};

export default educationHistory;
